var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"actividades"},[_c('actividades-form',{attrs:{"proyectoProp":_vm.proyecto,"actividad":_vm.id_actividad}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }